import { formatMoney } from "~/utils/formatMoney"
import moment from "moment"

const RentRollCard = ({ rentRollData, camp }) => {
  const {
    site_name,
    camper_name,
    lease_start_date,
    lease_end_date,
    monthly_rent,
    electricity_fees,
    service_fees,
    other_charges,
    credit_card_fees,
    tax_fees,
    total_owed,
    total_paid,
  } = rentRollData

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-4 border border-gray-200">
      <div className="mb-3 pb-2 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">{camper_name}</h3>
        <p className="text-sm text-gray-500">Site: {site_name}</p>
      </div>

      <div className="grid grid-cols-2 gap-2 mb-3">
        <div>
          <p className="text-xs text-gray-500">Lease Start</p>
          <p className="text-sm font-medium">{moment(lease_start_date).format("MM/DD/YYYY")}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Lease End</p>
          <p className="text-sm font-medium">{moment(lease_end_date).format("MM/DD/YYYY")}</p>
        </div>
      </div>

      <div className="mb-3 pb-2 border-b border-gray-200">
        <div className="flex justify-between items-center mb-2">
          <p className="text-sm font-medium text-gray-700">Monthly Rent</p>
          <p className="text-base font-semibold">{formatMoney(monthly_rent, camp?.currency)}</p>
        </div>
      </div>

      <div className="mb-3">
        <p className="text-sm font-medium text-gray-700 mb-2">Additional Fees</p>
        <div className="grid grid-cols-2 gap-x-4 gap-y-2">
          <div>
            <p className="text-xs text-gray-500">Electricity</p>
            <p className="text-sm">{formatMoney(electricity_fees, camp?.currency)}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Other Charges</p>
            <p className="text-sm">{formatMoney(other_charges, camp?.currency)}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Service Fees</p>
            <p className="text-sm">{formatMoney(service_fees, camp?.currency)}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Credit Card Fees</p>
            <p className="text-sm">{formatMoney(credit_card_fees, camp?.currency)}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Taxes</p>
            <p className="text-sm">{formatMoney(tax_fees, camp?.currency)}</p>
          </div>
        </div>
      </div>

      <div className="mt-4 pt-3 border-t border-gray-200">
        <div className="flex justify-between items-center mb-2">
          <div>
            <p className="text-xs text-gray-500">Total Owed</p>
            <p className="text-base font-medium">{formatMoney(total_owed, camp?.currency)}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Total Paid</p>
            <p className="text-base font-semibold text-gray-900">{formatMoney(total_paid, camp?.currency)}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RentRollCard
